import {
    CustomImage,
    ImageDetails,
    PrintPdfFontResponse,
    TextInformation,
} from "burde";
import { CalendarSizeDimensions } from "svg/constants";
import { D3Selection } from "svg/draw/draw-calendar";
import { drawCoverPage } from "svg/draw/draw-cover";

const drawSinglePageCover = (
    base: D3Selection,
    calendarSize: string,
    calendarDimensions: CalendarSizeDimensions,
    coverImage: ImageDetails | null,
    coverColor: string | null,
    customCoverImage: CustomImage | null,
    coverTexts: Array<TextInformation>,
    fontOptions: PrintPdfFontResponse | null,
) => {
    let container = base.append("div").attr("class", "svg-container");

    let svg = container
        .append("svg")
        .attr("width", "100%")
        .attr("height", "100%")
        .attr("preserveAspectRatio", "xMinYMin slice")
        .attr(
            "viewBox",
            `0 0 ${calendarDimensions.svgWidth} ${calendarDimensions.svgHeight}`,
        )
        .classed("svg-content", true);

    drawCoverPage(
        svg,
        calendarSize,
        calendarDimensions,
        coverImage,
        coverColor,
        customCoverImage,
        coverTexts,
        fontOptions,
    );
};

export { drawSinglePageCover };
